import { createApiAction, restApiActions } from 'redux/redux-actions';
import restApis from 'redux/restApis';
import { FIND_ORGANIZATION } from 'redux/constants';

const findOrganizationApi = restApis('accounts/find-organization').list;
export const findOrganization = createApiAction(FIND_ORGANIZATION, findOrganizationApi);

export default restApiActions('accounts');
